type ApiConfig = {
  host?: string;
};

export const apiConfig: ApiConfig = {};

export const apiPath = (path: string) =>
  [apiConfig.host ?? process.env.API_HOST ?? window.location.origin, path].join(
    ''
  );
